/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ArrayElement, BaseComponent, Component, Global, Intents } from '@jovotech/framework';

const SUPPORTED_THEMES = ['hell', 'dunkel'];

const STEPS = [
  'Zuerst, hole dir eine Tasse. ',
  'Fülle Wasser in den Wasserkocher. Für die meisten Tassen reichen circa 250 Milliliter. ',
  'Schalte den Wasserkocher an. ',
  'Während du wartest, lege den Teebeutel in die Tasse. ',
  'Das Wasser sollte gleich erhitzt sein. Warte kurz und Fülle es dann in die Tasse. ',
  'Jetzt ist das Wasser in der Tasse. Warte die auf der Verpackung angegebene Zeit, meist fünf Minuten. Nehme dann den Teebeutel heraus und genieße deinen Tee. Vorsicht: Heiß! ',
];

const WAITING_TIME =
  '<audio src="https://levooba.s3.eu-central-1.amazonaws.com/amzn_ui_sfx_gameshow_waiting_loop_10s_01.mp3"/>';
const REPROMPT = 'Weiter mit dem nächsten Schritt oder wiederholen?';

function increaseCounter(current: number): number {
  return current + 1;
}

@Global()
@Component()
export class GlobalComponent extends BaseComponent {
  LAUNCH() {
    this.$user.data.currentStep = parseInt('0', 10);
    return this.$send({
      message:
        'Willkommen zum Kochbuch. Hier erfährst du wie du ganz einfach leckeren Kräutertee machen kannst. Bist du bereit?',
      reprompt: 'Bist du bereit?',
      listen: true,
    });
  }

  UNHANDLED() {
    return this.LAUNCH();
  }

  END() {
    return this.StopIntent();
  }

  @Intents(['YesIntent', 'NextIntent'])
  YesIntent() {
    const step = this.$user.data.currentStep;
    if (step > STEPS.length) {
      return this.$send({
        message: 'Das war der letzte Schritt. Genieße deinen Tee. Bis demnächst. ',
        listen: false,
        platforms: {
          web: {
            // custom property for this example
          },
        },
      });
    }

    this.$user.data.currentStep = increaseCounter(step);
    return this.$send({
      message: STEPS[step] + WAITING_TIME + REPROMPT,
      reprompt: REPROMPT,
      listen: true,
      platforms: {
        web: {
          // custom property for this example
        },
      },
    });
  }

  @Intents(['PreviousIntent'])
  PreviousIntent() {
    let step = this.$user.data.currentStep - 2;
    if (step < 0) step = 0;
    this.$user.data.currentStep = increaseCounter(step);
    return this.$send({
      message: STEPS[step] + WAITING_TIME + REPROMPT,
      reprompt: REPROMPT,
      listen: true,
      platforms: {
        web: {
          // custom property for this example
        },
      },
    });
  }

  @Intents(['RepeatIntent', 'NoIntent'])
  RepeatIntent() {
    const step = this.$user.data.currentStep - 1;
    this.$user.data.currentStep = increaseCounter(step);
    return this.$send({
      message: STEPS[step] + WAITING_TIME + REPROMPT,
      reprompt: REPROMPT,
      listen: true,
      platforms: {
        web: {
          // custom property for this example
        },
      },
    });
  }

  @Intents(['StopIntent'])
  StopIntent() {
    return this.$send({
      message: 'Bis demnächst beim Kochbuch! ',
      listen: false,
      platforms: {
        web: {
          // custom property for this example
        },
      },
    });
  }

  @Intents(['SwitchThemeIntent'])
  switchTheme() {
    const theme = this.$entities.theme?.resolved;
    // if no theme was found or the theme is invalid
    if (!theme || !SUPPORTED_THEMES.includes(theme)) {
      return this.LAUNCH();
    }

    return this.$send({
      message: `Okay, ${theme} Modus. Und jetzt? Dunkel oder Hell`,
      listen: true,
      platforms: {
        web: {
          // custom property for this example
          theme,
        },
      },
    });
  }
}
